module.exports = __webpack_public_path__ + "assets/img/mecha-btn-148c5664.png";